import type { Typed } from 'services/api/fields/core';

export interface LocationAddress {
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
}
export interface LocationOptions {
  address: LocationAddress;
  [key: string]: any;
}

function getDefaults(): LocationOptions {
  return {
    id: '',
    name: '',
    address: { address1: null, address2: null, city: null, state: null, zip: null },
    timezone: null,
    archived: false,
    externalId: null,
    npiNumber: null,
    client: { id: '', name: '' },
    groupsCount: 0,
    groups: [],
  };
}

let Location: new <T extends LocationOptions>(options: T) => Typed<_Location<T>, T>;

class _Location<T extends LocationOptions = LocationOptions> {
  address!: LocationAddress;

  constructor(options: T) {
    const opts = { ...getDefaults(), ...options };
    Object.assign(this, opts);

    this.address = opts.address;
  }

  get formattedAddress(): string {
    const { address1, address2, city, state, zip } = this.address;
    const parts = [address1, address2, city, state, zip].filter(Boolean);

    if (!parts.length) return '';

    const street = [address1, address2].filter(Boolean).join(', ');
    const cityStateZip = [city, state].filter(Boolean).join(', ');
    const withZip = zip ? `${cityStateZip} ${zip}` : cityStateZip;

    return [street, withZip].filter(Boolean).join(', ');
  }
}

// eslint-disable-next-line prefer-const
Location = _Location as typeof Location;

export default Location;
export { Location };
export type Location<T extends LocationOptions = LocationOptions> = Typed<_Location<T>, T>;
